import axios from "axios";

//单独处理 学业诊断三期 不走封装的fetch
type Params = {
  body?: object;
  query?: {
    appid: number;
    timestamp: string;
    sign: string;
  };
};
const ENV = ENV_CUSTOM;
const URL_CONFIG = {
  development: "/api/school",
  production: "https://xuefu.xiwang.com/hcdiagnose",
  test: "https://xuefutest.xiwang.com/hcdiagnose",
};
axios.defaults.baseURL =
  ENV === "production" ? URL_CONFIG.production : URL_CONFIG.test;

export async function fetchReportDetail(params: Params = {}) {
  const { appid, timestamp, sign } = params.query;
  const { data } = await axios.post(
    `/api/report/edit-info?appid=${appid}&timestamp=${timestamp}&sign=${sign}`,
    {
      ...params.body,
    }
  );
  return data;
}
export async function reportPreview(params: Params = {}) {
  const { appid, timestamp, sign } = params.query;
  const { data } = await axios.post(
    `/api/report/preview?appid=${appid}&timestamp=${timestamp}&sign=${sign}`,
    { ...params.body }
  );
  return data;
}

export async function reportGenerate(params: Params = {}) {
  const { appid, timestamp, sign } = params.query;
  const { data } = await axios.post(
    `/api/report/regenerate?appid=${appid}&timestamp=${timestamp}&sign=${sign}`,
    { ...params.body }
  );
  return data;
}
